
import React, { useState } from 'react'

import { Button } from '@smart/design-system'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { de } from '../i18n'
import IconDownload from '../imgs/IconAdd'
import { ptSelectors } from '../store/pricingTool'

const DownloadEnergyLabelBtn = () => {
  const [downlaodInProgress, setDownlaodInProgress] = useState<boolean>(false)
  const entites = useSelector(ptSelectors.entities).devices
  const deviceId = useSelector(ptSelectors.form).deviceId

  const device = deviceId ? entites[deviceId] : {}
  const energyLabelSrc = device?.energy_label

  const onDownloadEnergyLabel = () => {
    setDownlaodInProgress(true)
    const link = document.createElement('a')
    link.href = `${process.env.REACT_APP_BACKEND_HOST || ''}${energyLabelSrc}?disposition=attachment`
    link.setAttribute(
      'download',
      `${device.description ?? ''}-${Math.floor(Date.now() / 10000)}_energyLabel`
    )
    document.body.appendChild(link)
    link.click()
    link.remove()
    setDownlaodInProgress(false)
  }

  return <Button
    style={{
      float: 'right',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}
    primary type="button"
    disabled={!energyLabelSrc || downlaodInProgress}
    title={energyLabelSrc ? undefined : de.noEnergyLableAvailable}
    onClick={() => {
      onDownloadEnergyLabel()
    }}>
    {downlaodInProgress ? <Loader /> : <IconDownload size={'20px'}/>}
    {de.exportEnergyLabel}
  </Button>
}

export { DownloadEnergyLabelBtn }

const Loader = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 3px solid #ffffff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
`
